export default __webpack_public_path__ + "static/media/api_icon.c98e7da7.png";